const emojiPicker = document.createElement('div')
emojiPicker.classList.add('emojis-window')

const addSupport = (emojiContainer, clickHandler) => {
  if (!emojiContainer) {
    return
  }

  emojiPicker.style.position = 'absolute'
  emojiPicker.style.zIndex = '999'
  emojiPicker.style.display = 'none'
  emojiPicker.style.width = '187px'
  emojiPicker.style.padding = '5px 2px 5px 5px'
  emojiPicker.style.marginTop = '5px'
  emojiPicker.style.overflow = 'hidden'
  emojiPicker.style.background = '#fff'
  emojiPicker.style.boxShadow = '0 1px 1px rgba(0, 0, 0, 0.1)'
  emojiPicker.style.borderRadius = '3px'
  emojiPicker.style.border = '1px #dfdfdf solid'

  const emojiTrigger = emojiContainer.getElementsByClassName('trigger')[0]

  emojiTrigger.onclick = () => {
    emojiPicker.style.display = emojiPicker.style.display === 'block' ? 'none' : 'block'
    let coords = emojiPicker.getBoundingClientRect()
    emojiPicker.style.top = -(coords.height + 10) + 'px'
  }

  emojiContainer.appendChild(emojiTrigger)

  const emojiList = document.createElement('ul')
  emojiList.classList.add('emojis-list')

  emojiList.style.padding = '0'
  emojiList.style.margin = '0'
  emojiList.style.listStyle = 'none'
  emojiList.style.display = 'flex'
  emojiList.style.flexWrap = 'wrap'

  const emojis = [0x1F601, 0x1F602, 0x1F603, 0x1F60D, 0x1F60A, 0x1F614, 0x1F613, 0x1F633, 0x1F631, 0x1F621, 0x1F648, 0x1F62D, 0x1F44D, 0x1F389]

  emojis.map((item) => {
    const emojiLink = document.createElement('a')

    emojiLink.style.textDecoration = 'none'
    emojiLink.style.border = 'none'
    emojiLink.style.margin = '5px'
    emojiLink.style.position = 'initial'
    emojiLink.style.fontSize = '24px'

    emojiLink.setAttribute('href', 'javascript:void(0)')
    emojiLink.innerHTML = String.fromCodePoint(item)
    emojiLink.onclick = clickHandler

    emojiList.appendChild(emojiLink)
  })

  if (emojiPicker.getElementsByClassName('emojis-list').length === 0) {
    emojiPicker.appendChild(emojiList)
  }
  emojiContainer.appendChild(emojiPicker)
}

const closePicker = function () {
  emojiPicker.style.display = 'none'
}

export default {
  addSupport,
  closePicker
}
